import styled from 'styled-components';

import { IconChevronDown } from '../../../common/icons/cdl/ChevronDown';

export const RotatingChevron = styled(IconChevronDown)<{ $isExpanded: boolean }>`
    transform: rotate(${(props) => (props.$isExpanded ? '-180deg' : '0deg')});
    transition: transform 150ms ease-in-out;
`;
